<nb-layout>
  <nb-layout-header>
    <img src="./assets/images/logo.svg" style="display: block; height: 100%;">
    <div>
      <a class="text-link sb-button-primary" routerLink="../auth/login">Login</a>
    </div>
  </nb-layout-header>
  <nb-layout-column>
    <main>
      <section class="hero">
        <div class="container">
          <div class="hero-inner">
            <div class="hero-copy">
              <h1 class="hero-title mt-0" ngsReveal>Increase sales from day one in the smartest way possible!</h1>
              <p class="hero-paragraph" ngsReveal>
                Reach a wider range of customers and get more feedback.
              </p>
              <div class="d-flex flex-column">
                <button class="sb-button-primary align-self-center align-self-md-start"
                        routerLink="auth/signup" ngsReveal>
                  Contact Us
                </button>
              </div>
            </div>
            <div class="hero-illustration" ngsReveal>
              <div class="hero-shape hero-shape-1">
                <svg width="40" height="40" xmlns="http://www.w3.org/2000/svg" style="overflow:visible">
                  <circle class="anime-element fadeup-animation" cx="20" cy="20" r="20" fill="#FFD8CD"
                          fill-rule="evenodd"/>
                </svg>
              </div>
              <div class="hero-shape hero-shape-2">
                <svg width="88" height="88" xmlns="http://www.w3.org/2000/svg" style="overflow:visible">
                  <circle class="anime-element fadeup-animation" cx="44" cy="44" r="44" fill="#FFD2DA"
                          fill-rule="evenodd"/>
                </svg>
              </div>
              <div class="hero-main-shape">
                <img src="../assets/icons/eating_together.svg" alt="Eating together with SmartBite Corporate"/>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="features section">
        <div class="container">
          <div class="features-inner section-inner">
            <div class="features-header text-center">
              <div class="container-sm">
                <h2 class="section-title mt-0">The SmartBite Experience</h2>
                <p class="section-paragraph">Your go-to office food solution.</p>
              </div>
            </div>
            <div class="features-wrap">
              <div class="feature text-center" ngsReveal>
                <div class="feature-inner">
                  <img src="../assets/icons/online-payment.svg">
                  <h3 class="feature-title h3-mobile mb-8">Additional Revenues</h3>
                  <p class="sb-text-cancel">Exploit your expertise and let us handle the logistics: we take orders,
                    you cook, we pick and deliver.
                    Easy!</p>
                </div>
              </div>
              <div class="feature text-center" ngsReveal>
                <div class="feature-inner">
                  <img src="../assets/icons/corporate.svg">
                  <h3 class="feature-title h3-mobile mb-8">Stable<br> Sales</h3>
                  <p class="sb-text-cancel">Selling with SmartBite will not hinder your restaurant’s
                    operations. Prepare meals during your off-peak hours to maximize productivity.</p>
                </div>
              </div>
              <div class="feature text-center" ngsReveal>
                <div class="feature-inner">
                  <img src="../assets/icons/employee.svg">
                  <h3 class="feature-title h3-mobile mb-8">Innovative Technology</h3>
                  <p class="sb-text-cancel">We invest in marketing and technology to reach your most ambitious goals.
                    Reach thousands active users, today!</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </nb-layout-column>
</nb-layout>
